import React, {useEffect, useState} from 'react';
import {
  Button,
  Icon,
  Menu,
  MenuItem,
  Position,
} from '@blueprintjs/core';
import {Popover2} from '@blueprintjs/popover2'
import {IconNames} from '@blueprintjs/icons';

import './SelectLimit.scss';

type OnChangeCallback = (value: any) => void;

interface SelectLimitProps {
  defaultLimit: any;
  onChange: OnChangeCallback;
  disabled?: boolean;
}

interface LimitMenuContentProps {
  value: string;
  onChange: OnChangeCallback;
}

const NO_LIMIT: string = 'No Limit'; // if limit is not set (null)

const LimitMenuContent = React.memo(({value, onChange}: LimitMenuContentProps) => {
  const options = [
    null, '10', '50', '100', '150', '1000', '10000', '100000', '200000', '500000'
  ];

  return (
    <Menu>
      {
        options.map((option) => (
          <MenuItem
            key={option}
            text={option ? `Limit ${option}` : NO_LIMIT}
            labelElement={value === option && <Icon icon={IconNames.TICK}/>}
            onClick={() => onChange(option)}
          />
        ))
      }
    </Menu>
  )
});

const SelectLimitComponent = ({
  defaultLimit,
  onChange,
  disabled = false,
}: SelectLimitProps) => {
  const [value, setValue] = useState(defaultLimit);

  const onLimitValueChange = (newValue: string) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div className="editor-footer__limit">
      <Popover2
        content={
          <LimitMenuContent
            value={value}
            onChange={onLimitValueChange}
          />
        }
        position={Position.BOTTOM_RIGHT}
      >
        <Button
          text={value ? `Limit ${value}` : NO_LIMIT}
          minimal={true}
          small={true}
          disabled={disabled}
          icon={IconNames.CARET_DOWN}
        />
      </Popover2>
    </div>
  );
}

export const SelectLimit = React.memo(SelectLimitComponent);
export default SelectLimit;
